export default __webpack_public_path__ + "static/media/selectTeam1.77ce56e2.mp3";